import { EditorOptionsState } from '@candulabs/craft';
import React, { useEffect } from 'react';

import { useEditor } from 'craft/hooks';

type ModeTogglerProps = {
  mode: EditorOptionsState['mode'];
};

/**
 * Sets the editor mode to match what is passed in to the component
 */
export const ModeToggler: React.FC<ModeTogglerProps> = React.memo(({ mode }: ModeTogglerProps) => {
  const { actions } = useEditor();
  useEffect(() => {
    actions.setOptions({ mode });
  }, [mode, actions]);

  return null;
});
